<template>
	<div class="timeline" :style="styles">
		<div v-for="row of data" :key="row.id" class="timeline-row">
			<div class="timeline-icon">
				<div
					class="timeline-icon_container"
					:style="{
						backgroundColor: getTimelineIcon(row.status).backgroundColor,
						color: getTimelineIcon(row.status).color,
					}"
				>
					<feather :type="getTimelineIcon(row.status).icon" size="18px" />
				</div>
			</div>
			<div class="timeline-content">
				<div class="timeline-content_top">
					<div :style="{ color: getTimelineIcon(row.status).color }">
						{{ row.status }}
					</div>
					<div>
						{{ returnElapsedTime(row.timestamp) }}
					</div>
				</div>
				<div class="timeline-content-details">
					<div class="timeline-content-details">
						<div v-if="row.amount" class="timeline-content-row">
							Valor: {{ transformToBrl(row.amount / 100) }}
						</div>
						<div v-if="row.orderId" class="timeline-content-row">Id Pedido: {{ row.orderId }}</div>
						<div v-if="row.timestamp" class="timeline-content-row">
							Data: {{ dateTimeToBrasilWithTimezone(row.timestamp) }}
						</div>
						<div v-if="row.brand" class="timeline-content-row">Bandeira: {{ row.brand }}</div>
						<div v-if="row.lastDigits" class="timeline-content-row">
							Últimos Digitos: {{ row.lastDigits }}
						</div>
						<div v-if="row.numberInstallments" class="timeline-content-row">
							Parcelas: {{ row.numberInstallments }}
						</div>
						<div v-if="row.descriptionDetail" class="timeline-content-row">
							Descrição: {{ row.descriptionDetail }}
						</div>
						<div class="timeline-content-row">
							{{ getTimelineIcon(row.status).description }}
						</div>

						<div v-if="validPaymentManual(row.gatewayPaymentId)" class="timeline-content-row">
							<a
								target="_blank"
								rel="noopener noreferrer"
								class="link"
								:href="returnDownloadUrl(row.gatewayPaymentId)"
								>Comprovante de Pagamento</a
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import cookie from 'vue-cookie';
import global from '../../../mixins/global';

export default {
	mixins: [global],
	props: {
		width: {
			type: String,
			default: '100%',
		},
		data: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			token: cookie.get('admtoken'),
		};
	},
	computed: {
		styles() {
			return {
				width: this.width,
			};
		},
	},
	methods: {
		getTimelineIcon(situacao) {
			switch (situacao) {
				case 'DENIED':
					return {
						icon: 'x',
						color: 'rgb(249, 58, 90)',
						backgroundColor: 'rgb(249, 58, 90, 0.08)',
						description: 'Pagamento negado.',
					};
				case 'DENY':
					return {
						icon: 'x',
						color: 'rgb(249, 58, 90)',
						backgroundColor: 'rgb(249, 58, 90, 0.08)',
						description: 'Pagamento não autorizado',
					};
				case 'CONFIRMED':
					return {
						icon: 'check',
						color: '#00751a',
						backgroundColor: 'rgb(0, 117, 26, 0.08)',
						description: 'Transação encontra-se confirmada e Finalizada.',
					};
				case 'AUTHORIZED':
					return {
						icon: 'shield',
						color: 'rgb(0, 91, 234)',
						backgroundColor: 'rgb(0, 91, 234, 0.08)',
						description:
							'Transação de Crédito com Confirmação Tardia. Transação encontra-se autorizada e aguardando confirmação.',
					};
				case 'NOT APPROVED':
					return {
						icon: 'x',
						color: 'rgb(249, 58, 90)',
						backgroundColor: 'rgb(249, 58, 90, 0.08)',
						description: 'Pagamento não autorizado',
					};
				case 'NOT VERIFIED':
					return {
						icon: 'alert-triangle',
						color: '##fb8500',
						backgroundColor: 'rgb(251, 133, 0, 0.08)',
						description:
							'O cartão inserido não é válido, está cancelado, bloqueado ou com restrições. Contatar a central do cartão.',
					};
				default:
					return {
						icon: 'check',
						color: '##000 ',
						backgroundColor: 'rgb(0, 117, 26, 0.08)',
						description: '',
					};
			}
		},
		validPaymentManual(gatewayId) {
			if (gatewayId) {
				const searchKey = gatewayId.search('PM');
				if (searchKey !== -1) {
					return true;
				}
			}
			return false;
		},
		returnDownloadUrl(paymentId) {
			if (paymentId.search('PM') !== -1) {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.GN_COMPROVANTE_PGTO_DOWNLOAD}/${paymentId}?token=${this.token}`;
				return url;
			}
			return '';
		},
	},
};
</script>

<style scoped>
.timeline-content-details {
	display: flex;
	flex-direction: column;
	font-size: 12px;
}
.timeline-content-row {
	display: flex;
	flex-direction: column;
	margin-bottom: 10px;
}
.timeline-row {
	display: flex;
	width: 100%;
	justify-content: space-between;
	margin: 10px 0;
}
.timeline-content {
	display: flex;
	width: 90%;
	flex-direction: column;
}
.link {
	color: #1761fd !important;
}
.timeline-icon {
	width: 10%;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
}
.timeline-icon::before {
	content: '';
	position: absolute;
	bottom: 0;
	top: 42px;
	left: 18px;
	border-left: 2px dotted #e3ebf6;
}
.timeline-icon_container {
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	box-shadow: 0px 0px 1px 0.25px;
	border: 2px solid #fff;
}
.timeline-content_top {
	width: 100%;
	height: 40px;
	margin-top: 7px;
	display: flex;
	color: #a4abc5 !important;
	font-weight: bold;
	font-size: 12px;
	flex-direction: row;
	justify-content: space-between;
}
</style>

